import { useSyncExternalStore } from 'react'
import type { SpellUnderlineRange } from '@/lib/spell-check/spell-check-state'
import { getSpellUnderlines, subscribeToSpellUnderlines } from '../shape-spell-underlines'

/** The misspelled words to underline in one text frame, redrawn only when its own ranges change. */
export function useShapeSpellUnderlines(shapeId: string): readonly SpellUnderlineRange[] {
  return useSyncExternalStore(subscribeToSpellUnderlines, () => getSpellUnderlines(shapeId))
}
